import * as React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import List from '@mui/material/List';

import ListItem from '@mui/material/ListItem';

import ListItemText from '@mui/material/ListItemText';


import { NavLink } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';

import RoutersArr from './../routes';

import { ThemeProvider } from "@mui/material/styles";

import setThemeObj from './../hooks/useThemeMUI';

import MDBoxRoot from "./MDBox/MDBoxRoot";

import MDButtonRoot from "./MDButton/MDButtonRoot";
import MDDrawerRoot from "./MDDrawer/MDdrawer";
import Tooltip from "@mui/material/Tooltip";
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "./MDsideNav/sidenavCollapse";

const getAdminStatus = gql(`
query GetAdminStatus {
  am_i_admin
}
`);

const getStaffStatus = gql(`
  query GetStaffStatus {
    am_i_staff
  }
  `);

export default function LeftToolbar({ id, wthT, isSmallScreen }) {

  const { loading, error, data: admin_flag } = useQuery(getAdminStatus);
  const { data: staff_flag } = useQuery(getStaffStatus);

  const [isModalProfOpen, setIsModalProfOpen] = React.useState(false);
  const { pathname } = useLocation();
  const [menuActive, setMenuActive] = React.useState(null);


  const handleClickOpen = () => {
    setIsModalProfOpen(true);
  };
  const handleClick = (id) => {
    setMenuActive(id);
  };

//______
  useEffect(() => {
    const activeItem = RoutersArr.find(item => pathname.startsWith(item.link));
    setMenuActive(activeItem ? activeItem.name : null);
  }, [pathname]); 

  
  const filteredRoutes = RoutersArr.filter(item => {
    if (!item.leftMenuFlag) return false;
    if (item.adminFlag && !admin_flag?.am_i_admin) return false;
    if (item.staffFlag && !staff_flag?.am_i_staff) return false;
    return true;
  });
//____modern

  return (
    <ThemeProvider theme={setThemeObj}>
      <List sx={{ textAlign: "center" }}>
        <MDBoxRoot pt={10} pb={1} px={isSmallScreen ? 1 :4} 
        textAlign="center" key="BR">
          <MDDrawerRoot
            variant="permanent"
            ownerState={{
              brand: "",
              transparentSidenav: false,
              whiteSidenav: false,
              miniSidenav: false,
              darkMode: false,
              color: "",
            }}
            ownerloyaut={{
              mt: "10px", mb: "10px", mr: "10px", ml: "10px",
              pt: "10px", pb: "10px", pr: "10px", pl: "10px",
              br: "12px", wth: wthT
            }}

            sx={{
              width: wthT, 
              flexShrink: 0, 
              "& .MuiDrawer-paper": {
                width: wthT, 
                boxSizing: "border-box",
              },
              "&.MuiDrawer-docked": {
                width: wthT, 
              }
            }}
          >
            {RoutersArr.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  {(() => {
                    var showLine = false;
                    if (!item.leftMenuFlag) return null;
                    if (item.adminFlag) {
                      if (admin_flag?.am_i_admin) showLine = true;
                    } else if (item.staffFlag) {
                      if (staff_flag?.am_i_staff) showLine = true;
                    } else showLine = true;

                    if (showLine) {
                      console.log(isSmallScreen)
                      return (
                        <NavLink to={item.link} key={item.link}>
                          <ListItem key={item.name} component="li">
                          <Tooltip 
                            title={isSmallScreen ? item.name : ""}
                            placement="right" 
                            arrow
                          >
                            <MDButtonRoot
                              ownerState={{
                                size: "small",
                                variant: "text2button",
                                color: "white",
                                textTransform: "none",
                                isActive: menuActive === item.name,
                                iconOnly: isSmallScreen,
                              }}
                              sx={{
                                textTransform: 'none',
                                width: '100%',
                                marginRight:0,
                                "& .MuiButton-startIcon": {
                                  marginRight: 0, 
                                  marginLeft: 0, 
                                },
                              }}
                              onClick={() => handleClick(item.name)}
                              startIcon={item.icon}
                            >
                              {isSmallScreen ? '' : (
                                <ListItemText
                                  primary={item.name}
                                  sx={(setThemeObj) =>
                                    collapseText(setThemeObj, {
                                      whiteSidenav: false,
                                      miniSidenav: false,
                                      darkMode: false,
                                      active: menuActive === item.name,
                                    })}
                                />)}
                            </MDButtonRoot>
                            </Tooltip>
                          </ListItem>
                        </NavLink>
                      )
                    }
                  })()}
                </React.Fragment>);
            })}
          </MDDrawerRoot></MDBoxRoot>
      </List>
    </ThemeProvider>
  );
}
